import '.j{display:grid;}.ssr-plugin'
import '.gw{grid-template-columns:repeat(2, minmax(250px, 1fr));}.ssr-plugin'
import '.u{gap:1rem;}.ssr-plugin'
import { useTranslations } from '@i18n/useLanguage'
import { pages } from '@app/util/links'
import { styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { useLocation } from 'wouter'
import { BlogCard } from '@app/components/blocks/card/BlogCard'
import Column from '@app/components/layout/Column'
import { Empty } from '@app/components/blocks/empty/Empty'
import PersonWithBinocularsImage from '@app/assets/images/person_with_binoculars.png'

export type KnowledgeHubModuleItem = {
  id: number
  slug: string
  title: string
  intro?: string
  images?: { src: string }[]
}

export const KnowledgeHubModulesSection = ({
  modules,
}: {
  modules: KnowledgeHubModuleItem[]
}) => {
  const t = useTranslations().app.knowledgeHubTab
  const [, setLocation] = useLocation()
  const title = t.title

  if (modules.length === 0) {
    return <Empty title={t.noModules} imageSrc={PersonWithBinocularsImage} />
  }

  return (
    <Column gap={'0.5rem'}>
      <Title.H4>{title}</Title.H4>
      <styled.div className="j gw u"
        style={{
          '@media (max-width: 1200px)': {
            gridTemplateColumns: 'repeat(1, minmax(250px, 1fr))',
          },}}
      >
        {modules.map((item) => (
          <BlogCard
            key={item.id}
            title={item.title}
            intro={item.intro}
            image={item.images?.[0]?.src}
            onClick={() => setLocation(pages.knowledgeHubModule(item.slug))}
          />
        ))}
      </styled.div>
    </Column>
  )
}
